<template>
  <van-nav-bar
    title="学生公寓自助选床"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
  <div class="infohouse" v-if="set.istime==true">
    <el-divider content-position="left">选择您的床位</el-divider>
    <el-card class="box-card" v-for="(item, i) in ruleForm.datas" :key="i">
      <template #header>
        <div class="card-header">
          <span
            >{{ item.building_Name }}-{{ item.house_Name }}
            <el-tag size="mini"
              >窗户朝向：朝{{ item.house_direction }}</el-tag
            ></span
          >
          <!-- <el-button class="button" type="text" @click="handleClose(item.house_Name)">看全景</el-button>        -->
        </div>
      </template>
      <div class="text item" v-for="(items, j) in item.zsfpItem" :key="j">
        <el-div
          class="radiodiv"
          v-if="items.student_IdNumber == null || items.student_IdNumber == ''"
          v-model="radio"
          :label="items.cw_ID"
          :class="{ radiodivselect: items.cw_ID == active }"
          border
          @click="
            changeRadio(
              item.building_Name +
                '-' +
                item.house_Name +
                '-' +
                items.cw_Name +
                '床' +
                items.cw_type +
                '，' +
                items.cw_price +
                '元/学年',
              items.cw_ID
            )
          "
          >{{ items.cw_Name + "床" }} {{ items.cw_type }} ({{
            items.cw_price
          }}元/年)
          <br />
          <p class="kongchuang">空床</p>
        </el-div>
        <el-div
          class="radiodivdis"
          disabled
          v-if="items.student_IdNumber != null"
          v-model="radio"
          :label="items.cw_ID"
          border
        >
          {{ items.cw_Name + "床" }} {{ items.cw_type }} ({{
            items.cw_price
          }}元/年)
          <br />
          <span v-if="items.student_Name != null" class="ratiospan">
            <el-tag size="small" type="success">{{
              items.student_Name
            }}</el-tag>
            <el-tag size="mini">{{ items.student_mz }}</el-tag>
            <el-tag type="danger" size="mini">{{
              items.student_Habits
            }}</el-tag>
          </span>
        </el-div>
      </div>
    </el-card>

    <p class="onInfo" v-if="inradios != ''">温馨提示：{{ inradios }}</p>
    <el-button
      class="onSubmit"
      @click="onSubmit(ruleForm.datas)"
      size="small"
      v-if="ruleForm.istrue && !ruleForm.MainDate"
      >提 交</el-button
    ><el-button
      class="onSubmit"
      @click="onview()"
      size="small"
      v-if="!ruleForm.istrue && !ruleForm.MainDate"
      >查看住宿确认表</el-button
    >
    <el-button class="onSubmit" size="small" v-if="ruleForm.MainDate"
      >已过选床时间</el-button
    >
  </div>
   <div v-if="set.istime!=true">
    <p v-html="set.info"></p>
  </div>
</template>

<style lang="scss" scoped>
.el-radio.is-bordered {
  height: 60px;
  line-height: 20px;
}
.kongchuang{
  text-align: center;
  font-size: 16px;
  margin:0 0 10px auto;
}
.ratiospan {
  color: black;
}
.radiodiv {
  height: 60px;
  line-height: 25px;
  border: 1px solid #059490;
  border-radius: 6px;
  display: block;
  cursor: pointer;
}
.radiodiv {
  height: 60px;
  line-height: 25px;
  border: 1px solid #059490;
  border-radius: 6px;
  display: block;
  cursor: pointer;
}

.radiodivselect {
  height: 60px;
  line-height: 25px;
  border: 1px solid #000;
  border-radius: 6px;
  display: block;
  cursor: pointer;
  background: #409eff;
  color: #fff;
}
.radiodiv:hover {
  height: 60px;
  line-height: 25px;
  border: 1px solid #409eff;
  border-radius: 6px;
  display: block;
  cursor: pointer;
  background: #409eff;
}
.radiodivdis {
  height: 60px;
  line-height: 25px;
  border: 1px solid #909399;
  border-radius: 6px;
  display: block;
  background: #c0c4cc;
}
.onSubmit {
  position: absolute;
  top: 100px;
  left: 10px;
  background-color: #059490;
  width: calc(100% - 30px);
  border: 1px solid #04726f;
  font-family: "Microsoft YaHei";
  color: #fff;
  text-align: center;
  border-radius: 6px;
  font-size: 16px;
}
.onInfo {
  position: absolute;
  top: 30px;
  left: 10px;
}
.infohouse {
  max-width: 1180px;
  margin: 100px 0 0 auto;
}
.el-radio {
  width: 100%;
  text-align: left;
}
.item {
  padding: 2px 0;
  width: 100%;
}
.box-card {
  margin: 15px 6px;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  margin-left: 30px;
  min-height: auto;
}

.image {
  width: 100%;
  display: block;
}
</style>

<script>
import { Toast } from "vant";
import { defineComponent } from "vue";
import { reactive } from "vue";
import { ref } from "vue";
import Route from "../../router/index";
import { GetHouseList } from "../../http/api.ts";
import { SaveSelectHouse } from "../../http/api.ts";
import { getTime } from "../../http/api.ts";
import { selecthose } from "../../http/api.ts";
import { GetWebSiteSet } from "../../http/api.ts";
import { Dialog } from "vant";

let inradio = "";
let cwID = "";

export default defineComponent({
  name: "mhouse",
  setup() {
    let ruleForm = reactive({
      datas: [],
      MainDate: false,
      istrue: false,
      mz: "",
    });
     let set =reactive({
      info:'',
      istime:false
    });
    let dataFun = async () => {
      await getTime().then((res) => {
        set.istime=res.datas;
        if(!res.datas){
          return false;
        }
        });
      await GetWebSiteSet().then((res) => {
          set.info=res.datas.openDesc;
      });
      await GetHouseList().then((res) => {
        ruleForm.datas = reactive(res.datas.zsfp);
        ruleForm.MainDate = reactive(res.datas.ZsfpMainDate);
        ruleForm.mz = reactive(res.datas.mz);
      });
      await selecthose().then((res) => {
        if (res.code == 200) {
          ruleForm.istrue = true;
        } else {
          ruleForm.istrue = false;
        }
      });
    };

    dataFun();
    const radio = ref("1");
    const inradios = ref("选床信息提交后不能修改。");
    return {
      ruleForm,
      radio,
      inradios,
      dialogVisible: false,
      active: 0,set
    };
  },
  methods: {
    goBack() {
      console.log("go back");
    },
    onSubmit() {
      if (inradio.length == 0) {
        Toast.fail("请选择您的床位！");
        return false;
      }

      getTime().then((res) => {
        if (!res.datas) {
           Dialog.alert({
                    title: '提示',
                    message: res.msg
                    ,allowHtml:true
                  });
        } else {
          Dialog.confirm({
            title: "提示",
            message: "您选择的是[" + inradio + "], 确认提交?",
          })
            .then(() => {
              // on confirm
              var toastload = Toast.loading({
                message: "程序正在处理，请耐心等待...",
                forbidClick: true,
                duration: 0,
              });
              const housepo = {
                cw_Id: cwID,
                source: "Phone",
                mz: this.ruleForm.mz,
              };
              SaveSelectHouse(housepo).then((res) => {
                if (res.code == 200) {                  
                  Dialog.alert({
                    title: "提示",
                    message:
                      "您已完成选床操作，请在PC端(http://gyxf.cuc.edu.cn)登录打印《中国传媒大学学生公寓住宿信息确认表》和《中国传媒大学学生公寓住宿协议书》，本人签字确认并粘贴一寸照片，办理入住手续时交于公寓管理人员。",
                    allowHtml: true,
                  }).then(() => {
                    Route.push("/m/houseview?tmsite="+Math.random());
                  });
                } else if (res.code == 201) {
                  Toast.fail(res.msg);
                } else if (res.code == 202) {
                  Toast.success(res.msg);
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
                } else if (res.code == 1001) {
                  Toast.fail("没有抢到，请重新提交床位！");
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
                }

                toastload.clear();
              });
            })
            .catch(() => {
              Toast.fail("已取消");
            });
        }
      });
    },
    changeRadio(event, cw_ID) {
      inradio = event;
      cwID = cw_ID;
      this.active = cw_ID;
      this.inradios = "您已选择：  " + event + " 。选床信息提交后不能修改。";
    },
    handleClose() {
      Route.push("/m/vr?tmsite="+Math.random());
    },
    onClickLeft() {
      history.go(-1);
    },
    onview() {
      Route.push("/m/houseview?tmsite="+Math.random());
    },
  },
});
</script>
